import { AnimatePresence } from 'framer-motion'
import { Route, Routes, useLocation } from 'react-router-dom'
import { PageWrapper } from './PageWrapper'

import { HomePage } from '../../pagesv2/HomePage'
import { UserProfile } from '../../pagesv2/user/UserProfile'
import { AnimeIndex } from '../../pagesv2/anime/AnimeIndex'
import { AnimeDetails } from '../../pagesv2/anime/AnimeDetails'
import { QuestionsAndAnswers } from '../../pagesv2/static/QuestionsAndAnswers'
import { PostIndex } from '../../pagesv2/post/PostIndex'
import { PostDetails } from '../PostSystem/PostDetails/PostDetails'
import { ForgotPassword } from '../../pagesv2/auth/ForgotPassword'
import { JapanTrip } from '../../pagesv2/static/JapanTrip'
import { AnimeGlossary } from '../../pagesv2/anime/AnimeGlossary'
import { PostForm } from '../../pagesv2/post/PostForm'
import { PrivacyPolicy } from '../../pagesv2/privacy/PrivacyPolicy'
import { AccessibilityStatement } from '../../pagesv2/privacy/AccessibilityStatement'
import { TermsOfUse } from '../../pagesv2/privacy/TermsOfUse'
import { Soon } from '../../pagesv2/static/Soon'
import Error from '../../pagesv2/static/Error'
import { useEffect } from 'react'
import { LexicalTextEditor } from '../TextEditor/LexicalTextEditor'
import { AnimeEditSuggestionForm } from '../../pagesv2/anime/AnimeEditSuggestionForm'
import { AnimeEditPage } from '../../pagesv2/anime/AnimeEditPage'

export function AnimatedRoutes({ loggedInUser, isDesktop, isAuthorizedAnime }) {
  const location = useLocation()

  return (
    <Routes location={location} key={location.key}>
      <Route
        path="/"
        element={
          <PageWrapper>
            <HomePage />
          </PageWrapper>
        }
      />
      <Route
        path="/animes"
        element={
          <PageWrapper>
            <AnimeIndex />
          </PageWrapper>
        }
      />
      <Route
        path="/text"
        element={
          <PageWrapper>
            <LexicalTextEditor />
          </PageWrapper>
        }
      />

      <Route path="/anime/edit/:animeId" element={<AnimeEditPage  />} />

      <Route
        path="/anime/:mal_id/:slug?"
        element={
          <PageWrapper>
            <AnimeDetails />
          </PageWrapper>
        }
      />
      <Route
        path="/faq"
        element={
          <PageWrapper>
            <QuestionsAndAnswers />
          </PageWrapper>
        }
      />
      <Route
        path="/posts/:title?/:tags?"
        element={
          <PageWrapper>
            <PostIndex />
          </PageWrapper>
        }
      />
      <Route
        path="/post/:postId"
        element={
          <PageWrapper>
            <PostDetails />
          </PageWrapper>
        }
      />
      <Route
        path="/user/:username"
        element={
          <PageWrapper>
            <UserProfile />
          </PageWrapper>
        }
      />
      <Route
        path="/create-post"
        element={
          loggedInUser ? (
            <PageWrapper>
              <PostForm />
            </PageWrapper>
          ) : null
        }
      />
      <Route
        path="/forgot-password"
        element={
          <PageWrapper>
            <ForgotPassword />
          </PageWrapper>
        }
      />
      <Route
        path="/japan-trip"
        element={
          <PageWrapper>
            <JapanTrip />
          </PageWrapper>
        }
      />
      <Route
        path="/anime-glossary"
        element={
          <PageWrapper>
            <AnimeGlossary />
          </PageWrapper>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <PageWrapper>
            <PrivacyPolicy />
          </PageWrapper>
        }
      />
      <Route
        path="/accessibility-statement"
        element={
          <PageWrapper>
            <AccessibilityStatement />
          </PageWrapper>
        }
      />
      <Route
        path="/terms-of-use"
        element={
          <PageWrapper>
            <TermsOfUse />
          </PageWrapper>
        }
      />
      <Route
        path="/soon"
        element={
          <PageWrapper>
            <Soon />
          </PageWrapper>
        }
      />
      <Route
        path="*"
        element={
          <PageWrapper>
            <Error />
          </PageWrapper>
        }
      />
    </Routes>
  )
}
